/**
 * c-rental-add-popup.js
 *
 * レンタル商品（BTA経由）カート追加後にお知らせポップアップを表示する。
 *
 * 仕組み:
 *   1. /cart.js を定期ポーリングして item_count の増加を検知（BTAの実装詳細に依存しない）
 *   2. 増加を検知したら BTAアドオンモーダルが開いているかチェックし、開いていれば閉じるまで待機
 *   3. モーダルが閉じた/開かなかった後、最終カート状態を取得してpopup表示
 */
(function () {
  'use strict';

  if (window.__cRentalAddPopupInit) return;
  window.__cRentalAddPopupInit = true;

  var MODAL_APPEAR_WAIT_MS = 3500;  // BTAアドオンモーダルが出現するかを待つ最大時間
  var MODAL_CLOSE_GRACE_MS = 700;   // モーダル閉じ後、最終 /cart/add.js POSTが終わるまでの猶予
  var NO_MODAL_GRACE_MS = 1500;     // モーダルが出現しなかった場合の追加 add を待つ時間
  var POLL_INTERVAL_MS = 150;

  /* ========================================
     1. カートポーリング
        /cart.js を定期的に取得して item_count 増加を検知する。
        BTAのiframe再生成・document差し替え・page部分再描画に影響されない。
     ======================================== */

  var POLL_MS = 1500;
  var lastKnownCount = null;
  var lastKnownItems = [];      // 追加検知前のアイテムスナップショット（差分計算用）
  var pendingBaselineItems = null; // 今回の追加に対するbaseline（resume時にsessionStorageから復元）
  var baselineLocked = false;

  var PENDING_KEY = 'cRapPendingPopup';
  var PENDING_TTL_MS = 30000;

  function startPolling() {
    resumePendingIfAny();

    fetchCart().then(function (c) {
      if (c) {
        lastKnownCount = c.item_count;
        lastKnownItems = snapshotItems(c);
      }
    });
    setInterval(pollCart, POLL_MS);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') pollCart();
    });
  }

  function resumePendingIfAny() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      sessionStorage.removeItem(PENDING_KEY);
      if (!data || Date.now() - data.ts > PENDING_TTL_MS) return;
      pendingBaselineItems = Array.isArray(data.baseline) ? data.baseline : [];
      baselineLocked = true;
      setTimeout(showPopupFromCurrentCart, 500);
    } catch (e) {}
  }

  function showPopupFromCurrentCart() {
    fetchCart().then(function (cart) {
      baselineLocked = false;
      if (!cart) return;
      lastKnownCount = cart.item_count;
      var baseline = pendingBaselineItems || lastKnownItems;
      pendingBaselineItems = null;
      var summary = buildRentalSummary(cart, baseline);
      lastKnownItems = snapshotItems(cart);
      if (!summary) return;
      renderPopup(summary);
    });
  }

  function markPendingPopup(baselineItems) {
    try {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify({
        ts: Date.now(),
        baseline: baselineItems || []
      }));
    } catch (e) {}
  }

  function snapshotItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.map(function (it) {
      return {
        variant_id: it.variant_id,
        quantity: it.quantity,
        addons_uuid: (it.properties && it.properties._addons_uuid) || null
      };
    });
  }

  function pollCart() {
    if (document.visibilityState !== 'visible') return;
    fetchCart().then(function (cart) {
      if (!cart) return;
      if (lastKnownCount === null) {
        lastKnownCount = cart.item_count;
        lastKnownItems = snapshotItems(cart);
        return;
      }
      if (baselineLocked) return;
      if (cart.item_count > lastKnownCount) {
        baselineLocked = true;
        pendingBaselineItems = lastKnownItems.slice();
        markPendingPopup(pendingBaselineItems);
        onBtaCartButtonClicked();
      } else if (cart.item_count !== lastKnownCount) {
        lastKnownCount = cart.item_count;
        lastKnownItems = snapshotItems(cart);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPolling);
  } else {
    startPolling();
  }

  /* ========================================
     2. クリック起点のカート監視
     ======================================== */

  function onBtaCartButtonClicked() {
    waitForBtaModalLifecycle(function () {
      fetchCart().then(function (cart) {
        if (!cart) { baselineLocked = false; return; }
        lastKnownCount = cart.item_count;
        baselineLocked = false;
        try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
        var baseline = pendingBaselineItems || [];
        pendingBaselineItems = null;
        var summary = buildRentalSummary(cart, baseline);
        lastKnownItems = snapshotItems(cart);
        if (!summary) return;
        renderPopup(summary);
      });
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  // BTAアドオンモーダルの出現→消滅を待つ。出現しなければ NO_MODAL_GRACE_MS 待って終了。
  function waitForBtaModalLifecycle(cb) {
    var deadline = Date.now() + MODAL_APPEAR_WAIT_MS;

    function isOpen() {
      var m = document.getElementById('bta-product-addons-modal');
      return !!(m && m.classList.contains('modal--visible'));
    }

    // Phase 1: 出現を待つ
    (function waitAppear() {
      if (isOpen()) { waitDisappear(); return; }
      if (Date.now() >= deadline) {
        setTimeout(cb, NO_MODAL_GRACE_MS);
        return;
      }
      setTimeout(waitAppear, POLL_INTERVAL_MS);
    })();

    // Phase 2: 消滅を待つ
    function waitDisappear() {
      if (!isOpen()) {
        setTimeout(cb, MODAL_CLOSE_GRACE_MS);
        return;
      }
      setTimeout(waitDisappear, POLL_INTERVAL_MS);
    }
  }

  /* ========================================
     3. レンタル商品の集計
     ======================================== */

  function isRentalItem(item) {
    if (item.product_type && /rental|レンタル/i.test(item.product_type)) return true;
    if (item.handle && /^rental-/i.test(item.handle)) return true;
    if (item.properties && item.properties._addons_uuid) return true;
    if (item.product_title === '保証金' || item.title === '保証金') return true;
    return false;
  }

  function getProp(item, key) {
    if (!item.properties) return '';
    return item.properties[key] || '';
  }

  // baseline (追加前のアイテム集合) と現cartを比較して新規追加分のみ抽出してpopup情報を作る
  function buildRentalSummary(cart, baselineItems) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return null;

    var baselineMap = {};
    (baselineItems || []).forEach(function (b) {
      var k = b.variant_id + '|' + (b.addons_uuid || '');
      baselineMap[k] = (baselineMap[k] || 0) + (b.quantity || 0);
    });

    // 新規追加（または数量増加）分だけ抽出。オリジナルitem + 追加数量 + 追加分の価格 を保持。
    var addedItems = [];
    cart.items.forEach(function (it) {
      var uuid = (it.properties && it.properties._addons_uuid) || '';
      var key = it.variant_id + '|' + uuid;
      var prevQty = baselineMap[key] || 0;
      var addedQty = it.quantity - prevQty;
      if (addedQty <= 0) return;
      addedItems.push({
        item: it,
        addedQty: addedQty,
        addedPrice: it.quantity > 0 ? Math.round(it.final_line_price * addedQty / it.quantity) : 0
      });
    });

    // baselineが空または差分なし（＝初回カート投入をbaseline取得前に逃したケース）は全レンタル商品をfallback
    if (addedItems.length === 0) {
      cart.items.forEach(function (it) {
        if (isRentalItem(it)) addedItems.push({ item: it, addedQty: it.quantity, addedPrice: it.final_line_price });
      });
    }

    // pivot: 追加分の中で「保証金でないレンタル商品」の最末尾。無ければ最末尾そのまま。
    var pivotEntry = null;
    for (var i = addedItems.length - 1; i >= 0; i--) {
      var it = addedItems[i].item;
      if (!isRentalItem(it)) continue;
      if (it.product_title === '保証金' || it.title === '保証金') continue;
      pivotEntry = addedItems[i];
      break;
    }
    if (!pivotEntry) {
      for (var j = addedItems.length - 1; j >= 0; j--) {
        if (isRentalItem(addedItems[j].item)) { pivotEntry = addedItems[j]; break; }
      }
    }
    if (!pivotEntry) return null;
    var pivot = pivotEntry.item;

    // 料金集計: 追加分の中のレンタル商品 / 保証金
    var rentalPrice = 0;
    var refundPrice = 0;
    addedItems.forEach(function (entry) {
      var it = entry.item;
      if (!isRentalItem(it)) return;
      if (it.product_title === '保証金' || it.title === '保証金') refundPrice += entry.addedPrice;
      else rentalPrice += entry.addedPrice;
    });

    return {
      productTitle: pivot.product_title || pivot.title || '',
      variantTitle: pivot.variant_title || '',
      imageUrl: pivot.image || (pivot.featured_image && pivot.featured_image.url) || '',
      start: getProp(pivot, 'Start'),
      finish: getProp(pivot, 'Finish'),
      rentalPrice: rentalPrice,
      refundPrice: refundPrice,
      total: rentalPrice + refundPrice,
      currency: cart.currency || 'JPY'
    };
  }

  /* ========================================
     4. ポップアップ描画（DOM API で構築）
     ======================================== */

  function formatMoney(cents) {
    var value = Math.round(cents / 100);
    return '¥' + value.toLocaleString('ja-JP');
  }

  function formatDate(str) {
    if (!str) return '';
    var m = String(str).match(/(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})/);
    if (!m) return str;
    return m[1] + '/' + String(m[2]).padStart(2, '0') + '/' + String(m[3]).padStart(2, '0');
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') node.className = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    if (children) children.forEach(function (c) {
      if (c == null) return;
      if (typeof c === 'string') node.appendChild(document.createTextNode(c));
      else node.appendChild(c);
    });
    return node;
  }

  function isSafeImageUrl(url) {
    if (!url) return false;
    return /^(https?:)?\/\//.test(url) || /^\//.test(url);
  }

  function ensureRoot() {
    var root = document.getElementById('c-rental-add-popup');
    if (root) return root;
    root = document.createElement('div');
    root.id = 'c-rental-add-popup';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'c-rap-title');
    document.body.appendChild(root);
    return root;
  }

  function buildProductBlock(s) {
    var thumb = isSafeImageUrl(s.imageUrl)
      ? el('img', { 'class': 'c-rap__thumb', src: s.imageUrl, alt: '', loading: 'lazy' })
      : el('div', { 'class': 'c-rap__thumb' });
    var name = el('p', { 'class': 'c-rap__product-name', text: s.productTitle });
    if (s.variantTitle) {
      var variantLine = el('span', {
        style: 'color:#888;font-size:12px;display:block;margin-top:2px;',
        text: s.variantTitle
      });
      name.appendChild(variantLine);
    }
    return el('div', { 'class': 'c-rap__product' }, [thumb, name]);
  }

  function buildDatesBlock(s) {
    if (!s.start || !s.finish) return null;
    return el('div', { 'class': 'c-rap__dates' }, [
      el('div', { 'class': 'c-rap__date' }, [
        el('p', { 'class': 'c-rap__date-label', text: '利用開始日' }),
        el('p', { 'class': 'c-rap__date-value', text: formatDate(s.start) })
      ]),
      el('span', { 'class': 'c-rap__arrow', 'aria-hidden': 'true', text: '→' }),
      el('div', { 'class': 'c-rap__date' }, [
        el('p', { 'class': 'c-rap__date-label', text: '返却予定日' }),
        el('p', { 'class': 'c-rap__date-value', text: formatDate(s.finish) })
      ])
    ]);
  }

  function buildSummaryBlock(s) {
    var rows = [
      el('div', { 'class': 'c-rap__row' }, [
        el('span', { text: 'レンタル料金' }),
        el('span', { 'class': 'c-rap__row-value', text: formatMoney(s.rentalPrice) })
      ])
    ];
    if (s.refundPrice > 0) {
      rows.push(el('div', { 'class': 'c-rap__row c-rap__row--refund' }, [
        el('span', { text: '保証金' }),
        el('span', { 'class': 'c-rap__row-value', text: formatMoney(s.refundPrice) })
      ]));
    }
    rows.push(el('div', { 'class': 'c-rap__row c-rap__row--total' }, [
      el('span', { text: 'お支払い合計' }),
      el('span', { 'class': 'c-rap__row-value', text: formatMoney(s.total) })
    ]));
    if (s.refundPrice > 0) {
      rows.push(el('p', { 'class': 'c-rap__note', text: '※ 保証金は返却・検品後に自動返金されます。' }));
    }
    return el('div', { 'class': 'c-rap__summary' }, rows);
  }

  function buildHeader() {
    return el('div', { 'class': 'c-rap__header' }, [
      el('span', { 'class': 'c-rap__check', 'aria-hidden': 'true', text: '✓' }),
      el('h2', { id: 'c-rap-title', 'class': 'c-rap__title', text: 'カートに追加しました' }),
      el('button', { type: 'button', 'class': 'c-rap__close', 'aria-label': '閉じる', 'data-c-rap-close': '', text: '×' })
    ]);
  }

  function buildActions() {
    return el('div', { 'class': 'c-rap__actions' }, [
      el('button', { type: 'button', 'class': 'c-rap__btn c-rap__btn--secondary', 'data-c-rap-close': '', text: '買い物を続ける' }),
      el('a', { 'class': 'c-rap__btn c-rap__btn--primary', href: '/cart', text: 'カートを見る' })
    ]);
  }

  function renderPopup(s) {
    var root = ensureRoot();
    while (root.firstChild) root.removeChild(root.firstChild);

    var backdrop = el('div', { 'class': 'c-rap__backdrop', 'data-c-rap-close': '' });
    var body = el('div', { 'class': 'c-rap__body' }, [
      buildProductBlock(s),
      buildDatesBlock(s),
      buildSummaryBlock(s)
    ]);
    var dialog = el('div', { 'class': 'c-rap__dialog' }, [buildHeader(), body, buildActions()]);

    root.appendChild(backdrop);
    root.appendChild(dialog);
    openPopup(root);
  }

  /* ========================================
     5. 開閉制御
     ======================================== */

  function openPopup(root) {
    root.classList.add('is-active');
    document.documentElement.classList.add('js-rap-open');
    var firstBtn = root.querySelector('.c-rap__btn--primary');
    if (firstBtn) firstBtn.focus();
    bindCloseOnce(root);
  }

  function closePopup() {
    var root = document.getElementById('c-rental-add-popup');
    if (!root) return;
    root.classList.remove('is-active');
    document.documentElement.classList.remove('js-rap-open');
  }

  function bindCloseOnce(root) {
    if (root.__cRapBound) return;
    root.__cRapBound = true;
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-c-rap-close]')) {
        e.preventDefault();
        closePopup();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-active')) closePopup();
    });
  }
})();
